/* SF02.04 — one browser-local owner. Store ID/URL only, never commerce truth. */
(() => {
  if (window.BMNewWishlist) return;
  const limit = 24;
  const key = 'bm.new.wishlist.v1';
  const valid = (entry) => {
    if (!entry || !/^\d+$/.test(String(entry.id))) return null;
    try {
      const url = new URL(entry.url, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[^/]+$/.test(url.pathname)) return null;
      return { id: String(entry.id), url: url.pathname };
    } catch (_) { return null; }
  };
  const read = () => {
    try {
      const entries = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(entries)) return [];
      return [...new Map(entries.map(valid).filter(Boolean).map(e => [e.id, e])).values()].slice(-limit);
    } catch (_) { return []; }
  };
  let entries = read();
  const announce = (text) => {
    let statuses = document.querySelectorAll('[data-wishlist-status]');
    if (!statuses.length && text) {
      const status = document.createElement('p');
      status.className = 'visually-hidden';
      status.dataset.wishlistStatus = '';
      status.setAttribute('role', 'status');
      document.body.append(status);
      statuses = [status];
    }
    statuses.forEach(el => { el.textContent = text; });
  };
  const sync = () => {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(entries.length); el.hidden = entries.length === 0; });
    document.querySelectorAll('[data-wishlist-empty]').forEach(el => { el.hidden = entries.length > 0; });
    document.querySelectorAll('[data-bm-new-wishlist]').forEach(button => {
      if (button.dataset.bmWishlistUnavailable !== undefined) { button.disabled = true; button.remove(); return; }
      const entry = valid({ id: button.dataset.productId, url: button.dataset.productUrl });
      button.disabled = !entry;
      const saved = entry && entries.some(e => e.id === entry.id);
      button.setAttribute('aria-pressed', String(Boolean(saved)));
      button.setAttribute('aria-label', saved ? 'Verwijderen uit verlanglijst' : 'Opslaan in verlanglijst');
      const icon = button.querySelector('svg');
      if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
      const text = button.querySelector('[data-bm-wishlist-label]');
      if (text) text.textContent = saved ? 'Verwijderen uit verlanglijst' : 'Opslaan in verlanglijst';
      else if (!icon) button.textContent = button.dataset.wishlistRemove !== undefined ? 'Verwijder' : saved ? 'Verwijderen uit verlanglijst' : 'Opslaan in verlanglijst';
    });
  };
  // The saved Shopify product is only an identity/media source. Commerce prices
  // come from the same validated Bridge product catalog used by the NEW PDP.
  const hydrateCanonicalPrice = async (card, productRef, signal) => {
    const client = window.BandenmeestersNewClient;
    if (typeof client?.productCatalog !== 'function') return;
    let catalog;
    try {
      catalog = await client.productCatalog(productRef, { signal, priceContract: 'OPTIONAL_CANONICAL_PRICE_V1' });
    } catch (_) { return; } // Keep the existing informational state on missing/unavailable prices.
    if (signal.aborted || catalog?.product?.shopifyProductRef !== productRef) return;
    const totals = (catalog.product.setOptions || [])
      .filter(option => option.setType === 'SQUARE' && option.defaultQuantity === 4
        && option.unitPrice?.currency === 'EUR'
        && Number.isSafeInteger(option.unitPrice.amountCents) && option.unitPrice.amountCents > 0)
      .map(option => option.unitPrice.amountCents * 4)
      .filter(Number.isSafeInteger);
    const price = card.querySelector('.bm-new-card__price');
    if (!totals.length || !price) return;
    const heading = document.createElement('span');
    heading.textContent = 'Vanaf ';
    const amount = document.createElement('strong');
    amount.textContent = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(Math.min(...totals) / 100);
    heading.append(amount);
    const unit = document.createElement('span');
    unit.className = 'bm-new-card__price-unit';
    unit.textContent = 'per set van 4 velgen';
    price.replaceChildren(heading, unit);
  };
  let renderVersion = 0;
  const requests = new Set();
  const render = async (restoreFocus = false) => {
    const grid = document.querySelector('[data-wishlist-items]');
    if (!grid) return;
    const version = ++renderVersion;
    requests.forEach(controller => controller.abort()); requests.clear();
    const height = grid.getBoundingClientRect?.().height || 0;
    if (height) grid.style?.setProperty('--bm-new-pending-height', `${height}px`);
    grid.setAttribute('aria-busy', String(entries.length > 0));
    grid.replaceChildren();
    announce(entries.length ? 'Verlanglijst laden…' : '');
    // Fetch fresh Shopify section HTML only for saved references, never on results cards.
    const slots = entries.map(entry => {
      const item = document.createElement('div');
      item.dataset.wishlistId = entry.id;
      const loading = document.createElement('p'); loading.textContent = 'Velg laden…'; item.append(loading);
      grid.append(item);
      return {entry,item};
    });
    const loadItem = async ({entry,item}) => {
      if (version !== renderVersion) return;
      const controller = new AbortController(); requests.add(controller);
      const timeout = setTimeout(() => controller.abort(), 10000);
      let unavailable = false;
      try {
        const response = await fetch(`${entry.url}?section_id=bm-new-wishlist`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        unavailable = response.status === 404 || response.status === 410;
        if (!response.ok) throw new Error('load_failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        unavailable = Boolean(doc.querySelector('[data-wishlist-unavailable]'));
        const card = doc.querySelector('.bm-new-card');
        if (unavailable) throw new Error('unavailable');
        if (!card || card.querySelector('[data-product-id]')?.dataset.productId !== entry.id) throw new Error('load_failed');
        if (version !== renderVersion) return;
        await hydrateCanonicalPrice(card, entry.id, controller.signal);
        if (version !== renderVersion) return;
        if (controller.signal.aborted) throw new Error('load_failed');
        item.replaceChildren(card);
      } catch (_) {
        if (version !== renderVersion) return;
        const message = document.createElement('p');
        message.textContent = unavailable ? 'Deze opgeslagen velg is niet meer beschikbaar.' : 'Deze velg kon niet worden geladen.';
        item.replaceChildren(message);
        if (!unavailable) {
          const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'bm-stock-control'; retry.textContent = 'Opnieuw proberen';
          retry.addEventListener('click', async () => {
            retry.disabled = true; retry.textContent = 'Laden…'; await loadItem({entry,item});
            (item.querySelector('.bm-new-card__cta') || item.querySelector('button'))?.focus();
          });
          item.append(retry);
        }
      } finally { clearTimeout(timeout); requests.delete(controller); }
      if (version !== renderVersion) return;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bm-stock-control';
      remove.dataset.bmNewWishlist = '';
      remove.dataset.wishlistRemove = '';
      remove.dataset.productId = entry.id;
      remove.dataset.productUrl = entry.url;
      remove.textContent = 'Verwijderen uit verlanglijst';
      item.append(remove);
      sync();
    };
    let next = 0;
    const worker = async () => { while (next < slots.length && version === renderVersion) await loadItem(slots[next++]); };
    await Promise.all(Array.from({length:Math.min(3,slots.length)},worker));
    if (version !== renderVersion) return;
    grid.setAttribute('aria-busy', 'false'); grid.style?.removeProperty('--bm-new-pending-height');
    announce(entries.length ? '' : '');
    sync();
    if (restoreFocus) {
      const target = grid.querySelector('.bm-new-card__cta') || grid.querySelector('button') || document.querySelector('[data-wishlist-browse]') || document.querySelector('[data-wishlist-status]');
      if (target) {
        if (target.hasAttribute('data-wishlist-status')) target.setAttribute('tabindex', '-1');
        target.focus();
      }
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bm-new-wishlist]');
    if (!button || button.disabled) return;
    const entry = valid({ id: button.dataset.productId, url: button.dataset.productUrl });
    if (!entry) return;
    const next = entries.some(e => e.id === entry.id) ? entries.filter(e => e.id !== entry.id) : [...entries, entry].slice(-limit);
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch (_) { announce('Opslaan is niet beschikbaar in deze browser.'); return; }
    entries = next;
    sync();
    render(Boolean(button.closest('[data-wishlist-items]')));
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { entries = read(); sync(); render(); } });
  document.addEventListener('shopify:section:load', () => { sync(); render(); });
  window.BMNewWishlist = { refresh: sync };
  sync();
  render();
})();
